// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ig-0";
export var actionModalContentContainer = "_ig-1";